import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function translateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

/**
 * Default loader according to ngx-translate/core
 * @see https://github.com/ngx-translate/core#configuration
 * @example ```TranslateModule.forRoot({ loader: defaultTranslateLoader })```
 */
export const defaultTranslateLoader = {
  provide: TranslateLoader,
  useFactory: translateLoaderFactory,
  deps: [HttpClient]
};



// WEBPACK FOOTER //
// ./src/translate.ts